import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import pushToAnalytics from '../../../lib/analytics';
import { aopAnalyticsSteps } from '../../../lib/analyticsHelper';
import Config from '../../../Config';

const config = new Config();

const LinkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    fill="currentColor"
    className="bi bi-box-arrow-up-right boxArrowIcon"
    viewBox="0 -1.4 16 16"
  >
    <path
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth="1.25"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0
      1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0
      1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
    />
    <path
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth="1.25"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0
      .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
    />
  </svg>
);

const RestrictedMarginModal = (props) => {
  const {
    onClose,
    existingMarginAccounts,
    applicationId,
    authToken,
    accountType,
    registration,
  } = props;

  const publishAnalytics = (stepName) => {
    pushToAnalytics(stepName, {
      applicationId,
      authToken,
      accountType,
      registration,
    });
  };

  const includesCompletedAccountStatus = existingMarginAccounts.some(account => account.AccountStatus === 'Completed');
  const accountNumbers = existingMarginAccounts.length > 3
    ? `${existingMarginAccounts.slice(0, 3).map(acc => acc.AccountNumber).join(', ')}, ...`
    : existingMarginAccounts.map(acc => acc.AccountNumber).join(', ');
  const accountLabel = existingMarginAccounts.length === 1 ? 'Account:' : 'Accounts:';
  const clientHubBaseUrl = config.hubBaseUrl.replace(/\?optin=true$/, '');
  const clientHubFundingUrl = `${clientHubBaseUrl}/dashboard#transfers/deposit/methods`;
  const displayAccountNumbers = accountNumbers && accountNumbers.length > 0;

  publishAnalytics(includesCompletedAccountStatus ?
    aopAnalyticsSteps.MARGIN_DISABLED_FUNDED_ACCOUNT.name :
    aopAnalyticsSteps.MARGIN_DISABLED_PENDING_FUNDING.name);

  return (
    <Modal
      show
      onHide={onClose}
      backdrop
      centered
      className="options-submit-modal"
    >
      <div className="options-submit-modal-div">
        <Modal.Header closeButton id="options-modal-title">
          <h1 id="page-header" className="h1_secondary">
            Margin Access Unavailable
          </h1>
        </Modal.Header>
        {includesCompletedAccountStatus &&
          <div>
            <Modal.Body className="options-submit-modal-body">
              <p className="panel-question">
                Margin access is not available for this account application because a margin account with the same
                ownership already exists. To open a cash account simply continue the current account application. If
                you have questions, please&nbsp;
                <a href="https://www.tradestation.com/contact-us/" target="_blank" rel="noopener noreferrer">
                  contact us
                </a>.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-raised btn-default do_capitalize"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </Modal.Footer>
          </div>
        }
        {!includesCompletedAccountStatus &&
          <div>
            <Modal.Body className="options-submit-modal-body">
              <p className="panel-question">
                Margin access is not available for this account application because a margin account with the
                same ownership already exists and is ready to receive funds to enable trading
                {displayAccountNumbers &&
                  <span>
                    &nbsp;(<span className="margin-disabled-modal-account-numbers">
                      <b>{accountLabel}</b> {accountNumbers}
                    </span>)
                  </span>
                }.
                <br /><br />
                How would you like to proceed?
              </p>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-default back-button do_capitalize options-submit-modal-button"
                  onClick={() => {
                    onClose();
                    publishAnalytics(aopAnalyticsSteps.MARGIN_DISABLED_POPUP_OPEN_CASH_ACCOUNT.name);
                  }}
                >
                  Open Cash Account
                </button>
                <button
                  type="button"
                  className="btn btn-raised btn-default do_capitalize options-submit-modal-button"
                  onClick={() => {
                    window.open(clientHubFundingUrl, '_blank', 'noopener,noreferrer');
                    publishAnalytics(aopAnalyticsSteps.MARGIN_DISABLED_POPUP_FUND_ACCOUNT.name);
                  }}
                >
                  Fund My Account {LinkIcon}
                </button>
              </div>
            </Modal.Footer>
          </div>
        }
      </div>
    </Modal>
  );
};

RestrictedMarginModal.propTypes = {
  onClose: PropTypes.func,
  existingMarginAccounts: PropTypes.arrayOf(PropTypes.shape()),
  applicationId: PropTypes.string,
  authToken: PropTypes.string,
  accountType: PropTypes.shape(),
  registration: PropTypes.shape(),
};

export default RestrictedMarginModal;
